import { render, staticRenderFns } from "./ChangeVisionForm.vue?vue&type=template&id=22cee580&"
import script from "./ChangeVisionForm.vue?vue&type=script&lang=js&"
export * from "./ChangeVisionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports